export const TYPES = {
  BOLDED: 'SUBTITLE',
  NORMAL: 'BODY',
}
